export default {
  questions: [
    {
      questionId: 1,
      questionText:
        "ในประเทศทั้งหมดในโลกที่มีรายได้น้อยทุกวันนี้ มีเด็กผู้หญิงจำนวนเท่าไหร่ ที่จบการศึกษาระดับประถม",
      choices: [
        { choiceId: "A", text: "ร้อยละ 20" },
        { choiceId: "B", text: "ร้อยละ 40" },
        { choiceId: "C", text: "ร้อยละ 60" }
      ],
      showAnswer: false,
      correctedAnswer: "C",
      userAnswer: ""
    },
    {
      questionId: 2,
      questionText: "ประชากรส่วนใหญ่ของโลกอาศัยอยู่ใน",
      choices: [
        { choiceId: "A", text: "ประเทศที่มีรายได้น้อย" },
        { choiceId: "B", text: "ประเทศที่มีรายได้ปานกลาง" },
        { choiceId: "C", text: "ประเทศที่มีรายได้สูง" }
      ],
      showAnswer: false,
      correctedAnswer: "B",
      userAnswer: ""
    },
    {
      questionId: 3,
      questionText:
        "20 ปีที่ผ่านมา สัดส่วนของประชากรโลกที่อยู่อย่างยากจนข้นแค้นมีจำนวน...",
      choices: [
        { choiceId: "A", text: "เพิ่มขึ้นเกือบเท่าตัว" },
        { choiceId: "B", text: "ใกล้เคียงเดิม" },
        { choiceId: "C", text: "ลดลงเกือบครึ่งหนึ่ง" }
      ],
      showAnswer: false,
      correctedAnswer: "C",
      userAnswer: ""
    },
    {
      questionId: 4,
      questionText: "อายุเฉลี่ยของคนในโลกปัจจุบันนี้อยู่ที่",
      choices: [
        { choiceId: "A", text: "50 ปี" },
        { choiceId: "B", text: "60 ปี" },
        { choiceId: "C", text: "70 ปี" }
      ],
      showAnswer: false,
      correctedAnswer: "C",
      userAnswer: ""
    },
    {
      questionId: 5,
      questionText:
        "ทุกวันนี้มีเด็กอายุ 0 - 15 ปีจำนวนสองพันล้านคนบนโลก ในปี 2100 จะมีเด็กจำนวนเท่าไหร่ตามข้อมูลขององค์การสหประชาชาติ",
      choices: [
        { choiceId: "A", text: "สี่พันล้านคน" },
        { choiceId: "B", text: "สามพันล้านคน" },
        { choiceId: "C", text: "สองพันล้านคน" }
      ],
      showAnswer: false,
      correctedAnswer: "C",
      userAnswer: ""
    },
    {
      questionId: 6,
      questionText:
        "องค์การสหประชาชาติคาดการณ์ว่าในปี 2100 ประชากรโลกจะเพิ่มขึ้นอีกสี่พันล้านคน ด้วยเหตุผลหลักคือ",
      choices: [
        {
          choiceId: "A",
          text: "มีเด็ก​ (อายุน้อยกว่า 15 ปี) จำนวนมากขึ้น"
        },
        { choiceId: "B", text: "มีผู้ใหญ่ (อายุ 15 - 17 ปี) จำนวนมากขึ้น" },
        {
          choiceId: "C",
          text: "มีคนสูงอายุ (อายุมากกว่า 75 ปี) จำนวนมากขึ้น"
        }
      ],
      showAnswer: false,
      correctedAnswer: "B",
      userAnswer: ""
    },
    {
      questionId: 7,
      questionText:
        "จำนวนคนที่เสียชีวิตจากภัยธรรมชาติในช่วงหนึ่งร้อยปีที่ผ่านมาเปลี่ยนแปลงไปอย่างไร",
      choices: [
        { choiceId: "A", text: "เพิ่มขึ้นมากกว่าเท่าตัว" },
        { choiceId: "B", text: "ใกล้เคียงเดิม" },
        { choiceId: "C", text: "ลดลงน้อยกว่าครึ่ง" }
      ],
      showAnswer: false,
      correctedAnswer: "C",
      userAnswer: ""
    },
    {
      questionId: 8,
      questionText:
        "ปัจจุบันมีคนอาศัยอยู่บนโลกประมาณเจ็ดพันล้านคน ภาพใดแสดงที่อยู่ของคนบนโลกได้ดีที่สุด (ภาพ 1 คนแทนประชากรหนึ่งพันล้านคน)",
      choices: [
        { choiceId: "A", text: "ภาพแรก" },
        { choiceId: "B", text: "ภาพที่สอง" },
        { choiceId: "C", text: "ภาพที่สาม" }
      ],
      showAnswer: false,
      correctedAnswer: "A",
      userAnswer: ""
    },
    {
      questionId: 9,
      questionText:
        "มีเด็กอายุ 1 ปีจำนวนเท่าไหร่ที่ได้รับวัคซีนป้องกันโรคในปัจจุบัน",
      choices: [
        { choiceId: "A", text: "ร้อยละ 20" },
        { choiceId: "B", text: "ร้อยละ 50" },
        { choiceId: "C", text: "ร้อยละ 80" }
      ],
      showAnswer: false,
      correctedAnswer: "C",
      userAnswer: ""
    },
    {
      questionId: 10,
      questionText:
        "ผู้ชายอายุ 30 ปีทั่วโลกเคยผ่านการเรียนหนังสือในโรงเรียนเฉลี่ย 10 ปี ผู้หญิงอายุเท่ากันมีเวลาเรียนเฉลี่ยเท่าไหร่",
      choices: [
        { choiceId: "A", text: "9 ปี" },
        { choiceId: "B", text: "6 ปี" },
        { choiceId: "C", text: "3 ปี" }
      ],
      showAnswer: false,
      correctedAnswer: "A",
      userAnswer: ""
    },
    {
      questionId: 11,
      questionText:
        "ในปี 1996 เสือ หมีแพนด้า และแรดดำถูกจัดเป็นสัตว์ที่ใกล้สูญพันธุ์ สัตว์ในกลุ่มนี้ปัจจุบันยังเหลือกี่ชนิดที่ใกล้สูญพันธุ์",
      choices: [
        { choiceId: "A", text: "2 ชนิด" },
        { choiceId: "B", text: "1 ชนิด" },
        { choiceId: "C", text: "0 ชนิด" }
      ],
      showAnswer: false,
      correctedAnswer: "C",
      userAnswer: ""
    },
    {
      questionId: 12,
      questionText: "ประชากรโลกจำนวนเท่าไหร่ที่เข้าถึงไฟฟ้า",
      choices: [
        { choiceId: "A", text: "ร้อยละ 20" },
        { choiceId: "B", text: "ร้อยละ 50" },
        { choiceId: "C", text: "ร้อยละ 80" }
      ],
      showAnswer: false,
      correctedAnswer: "C",
      userAnswer: ""
    },
    {
      questionId: 13,
      questionText:
        "ผู้เชี่ยวชาญด้านภูมิอากาศโลกเชื่อว่า อีก 100 ปีข้างหน้าอุณหภูมิเฉลี่ยของโลกจะ...",
      choices: [
        { choiceId: "A", text: "เพิ่มขึ้น" },
        { choiceId: "B", text: "เท่าเดิม" },
        { choiceId: "C", text: "ลดลง" }
      ],
      showAnswer: false,
      correctedAnswer: "A",
      userAnswer: ""
    }
  ]
};
